export default {
  filters: {
    maxZeroFilter: function (val) {
      return Math.max(val, 0)
    }
  }
}
